<template>
    <div class="imagescroll-container">
        <vue-seamless-scroll :data="imgList" :class-option="scrollOption" class="seamless-wrapper">
            <ul class="img-container" :style="{width: (imgList.length * 318) + 'px'}">
                <li @click="goLink(item.link)" v-for="item in imgList" class="img-item">
                    <img :src="item.image" alt="">
                </li>
            </ul>
        </vue-seamless-scroll>
    </div>
</template>

<script>
    import vueSeamlessScroll from 'vue-seamless-scroll'
    export default {
        props: {
            imgList: {
                type: Array,
                default: () => []
            }
        },
        components: { vueSeamlessScroll },
        data() {
            return {
                dataList: [],
                timerId: "",
                count: 0,
                stopFlag: false,
                mousePosition_down: "",//鼠标点击时的位置
                contentListWidth: '',//list的宽度
                listLength: 2,//要显示的图片占据的list
                moveFlag: false,//鼠标拖动时，阻止路由跳转,
                scrollOption:{
                    direction: 2,
                    limitMoveNum: this.imgList.length
                }
            }
        },
        mounted () {
          console.log(this.imgList,'滚动')
        },
        methods: {
          goLink(link) {
            window.open(link, '_blank')
          }
        }
    }
</script>

<style scoped>
    .imagescroll-container {
        width: 100%;
        overflow: hidden;
    }
    .seamless-wrapper {
        height: 80px;
        overflow: hidden;
        width: 1120px;
    }
    .img-container {
        width: 1590px;
        height: 100%;
    }
    .img-item {
        float: left;
        margin-right: 48px;
        width: 270px;
        height: 80px;
        cursor: pointer;
    }
    .img-item img {
        width: 100%;
        height: 80px;
        filter: grayscale(100%);
    }
    .img-item img:hover {
        filter: none;
        transition: 0.2s ease-in-out;
    }
</style>